import classes from "../classes";
import pure from "./higher-order/pure";
import React from "react";

export default pure(({ lane, small }) => {
  return (
    <span className={classes({
      "towel": true,
      "towel--small": small,
      ["towel--" + lane]: true
    })} />
  );
});
